<template>
    <div>
        <pageHead :title="title" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></pageHead>
        <div class="content">
            <div class="search">
                <i-form ref="search" :model="query">
                    <row :gutter="80">
                        <i-col span="6">
                            <form-item label="受理编号" prop="estateNO">
                                <Input v-model="query.estateNO" clearable placeholder="请输入受理编号" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="证书编号" prop="certNO">
                                <Input v-model="query.certNO" clearable placeholder="请输入证书编号" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="印刷编号" prop="printNO">
                                <Input v-model="query.printNO" clearable placeholder="请输入印刷编号" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="发证人" prop="issueUser">
                                <Input v-model="query.issueUser" clearable placeholder="请输入发证人" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="取证人" prop="takeUser">
                                <Input v-model="query.takeUser" clearable placeholder="请输入取证人" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="取证人证件号" prop="takeUserZjh">
                                <Input v-model="query.takeUserZjh" clearable placeholder="请输入取证人证件号" />
                            </form-item>
                        </i-col>
                        <!-- <i-col span="6">
                            <form-item label="租赁开始时间" prop="compactStartdate">
                                <DatePicker type="date" clearable v-model="query.compactStartdate" style="width: 100%;"></DatePicker>
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="租赁结束时间" prop="compactEnddate">
                                <DatePicker type="date" clearable v-model="query.compactEnddate" style="width: 100%;"></DatePicker>
                            </form-item>
                        </i-col> -->
                    </row>
                </i-form>
            </div>
            <div class="table-data">
                <i-table :columns="tableHeader" :border="true" :loading="isLoading" :data="tableData" stripe ref="table" @on-row-dblclick="handleClickDetail" @on-selection-change="handleSelect">
                    <template slot-scope="{ row, index }" slot="issueCertTime">
                        {{row.issueCertTime | formatData}}
                    </template>
                    <template slot-scope="{ row, index }" slot="takeTime">
                        {{row.takeTime | formatData}}
                    </template>
                    <template slot-scope="{ row, index }" slot="action">
                        <span @click="handleClickDetail(row)" class="action">[详情]</span>
                    </template>
                </i-table>
                <div class="page">
                    <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
import miment from "miment";
const {
    estatePrintLogList,
} = api
export default {
    name: "printCertificate",
    components: {
        pageHead
    },
    filters: {
        formatData(value){
            return miment(Number(value)).format("YYYY-MM-DD")
        }
    },
    data() {
        return {
            title: "不动产证书打印日志",
            btnList: [{
                name: "重置",
                type: "reset",
            },
            {
                name: "搜索",
                type: "search",
            }
            ],
            query: {
                estateNO: "",
                certNO: "",
                printNO: "",
                issueUser: "",
                takeUser: "",
                takeUserZjh: ""
            },
            tableHeader: [{
                type: "selection",
                width: 70,
                align: "center",
            }, {
                title: "受理编号",
                key: "estateNO",
            }, {
                title: "证书编号",
                key: "certNO",
            }, {
                title: "印刷编号",
                key: "printNO",
            }, {
                title: "发证时间",
                slot: "issueCertTime",
            }, {
                title: "发证人",
                key: "issueUser",
            }, {
                title: "取证人",
                key: "takeUser",
            }, {
                title: "取证人证件号",
                key: "takeUserZjh",
            }, {
                title: "取证时间",
                slot: "takeTime",
            }, {
                title: "项目（小区）",
                key: "projectName",
            }, {
                title: "操作",
                slot: "action",
            }],
            tableData: [],
            isLoading: false,
            pageNum: 1,
            pageSize: 10,
            total: 0,
            selectedList: [],
            zlyt: ["住宅", "办公", "商业"],
        }
    },
    methods: {
        handleBtn(type) {
            if (type == "reset") {
                this.pageNum = 1;
                this.$refs.search.resetFields();
                this.query.zlyt = ""
                this.loadData();
            } else if (type == "search") {
                this.pageNum = 1;
                this.loadData();
            }
        },
        handleClickDetail(item) {
            this.$router.push({
                name: "printCertificateDetail",
                query: {
                    id: item.id 
                }
            });
        },
        handleSelect(selection) {
            this.selectedList = selection.map(item => item.id)
        },
        pageChange(val) {
            this.pageNum = val;
            this.loadData();
        },
        async loadData() {
            this.isLoading = true;
            try {
                let res = await this.$post(estatePrintLogList, {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    ...this.query,
                });

                this.tableData = res.rows
                this.total = res.total
            } finally {
                this.isLoading = false;
            }
        }
    },
    created() {
        this.loadData();
        console.log(this.$route);
    },
}
</script>

<style lang="less" scoped>
.content {
    margin: 20px;
}

.search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
}

.table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);

    .page {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }

    .action {
        color: #5e6d94;
        cursor: pointer;
        margin-right: 10px;
    }
}
</style>